import script from "./RobotShowMode.vue?vue&type=script&setup=true&lang=js"
export * from "./RobotShowMode.vue?vue&type=script&setup=true&lang=js"

import "./RobotShowMode.vue?vue&type=style&index=0&id=6ac6a44c&lang=scss"

const __exports__ = script;

export default __exports__